<template>
    <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-8 offset-xl-2" v-html="value.code"></div>
    </div>
</template>

<script>
export default {
    name:'Embed',
    props:['value'],
    mounted() {
        if (this.value.code.includes('www.instagram.com/embed.js')) {
            if (!window.instgrm) {
                const embed = document.createElement('script')
                embed.src = 'https://www.instagram.com/embed.js'
                document.body.appendChild(embed)
            } else {
                window.instgrm.Embeds.process();
            }
        }

        if (this.value.code.includes('platform.twitter.com/widgets.js')) {
            if (!window.twttr) {
                const embed = document.createElement('script');
                embed.src = 'https://platform.twitter.com/widgets.js';
                document.body.appendChild(embed);
            } else {
                window.twttr.widgets.load();
            }
        }
    }
}
</script>